import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import {
  NOTIFICATION_MESSAGES,
  NOTIFICATION_PERMISSIONS
} from "../Notification/constants/NotificationConstants";
import { Http } from "@status/codes";
import { NotificationService } from "../Notification/services/NotificationService";
import { Subscription } from "../Notification/models/Subscription";
import { Utils } from "../../shared/utils/utils";
import { FORM_CONSTANTS } from "../../shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import ContextPanel from "./components/ContextPanel/ContextPanel.vue";
import ChatWindow from "./components/ChatWindow/ChatWindow.vue";
import LocalChatWindow from "./components/LocalChatWindow/LocalChatWindow.vue";

@Component({
  name: "Home",
  components: {
    ContextPanel,
    ChatWindow,
    LocalChatWindow
  }
})
export default class Home extends Vue {
  @Inject() notificationService!: NotificationService;
  contextPanelStatus = false;
  contentCols = 8;
  panelCols = 4;

  get isChatAssistant(): boolean {
    try {
      return this.$route?.name === "ChatAssistant";
    } catch {
      return false;
    }
  }

  async mounted() {
    await this.createSubscription();
  }

  async createSubscription(): Promise<void> {
    if (
      Notification.permission === NOTIFICATION_PERMISSIONS.DENIED ||
      !(FORM_CONSTANTS.GLOBAL_VARS.SERVICE_WORKER in navigator) ||
      !(FORM_CONSTANTS.GLOBAL_VARS.PUSH_MANAGER in window)
    ) {
      return;
    }

    Notification.requestPermission()
      .then(async respo => {
        if (respo == NOTIFICATION_PERMISSIONS.GRANTED) {
          const uid = localStorage.getItem("UID");

          if (uid) {
            const registration = await navigator.serviceWorker.getRegistration();
            registration?.pushManager
              .subscribe({
                userVisibleOnly: true,
                applicationServerKey: Utils.urlBase64ToUint8Array(
                  process.env.VUE_APP_PUBLIC_VAPID_KEY as string
                )
              })
              .then(async subscription => {
                const data: Subscription = {
                  subscription: JSON.parse(JSON.stringify(subscription)),
                  userKey: uid
                };
                const response = await this.notificationService.saveSubscription(
                  data
                );

                if (response.code !== Http.Ok) {
                  Snackbar.popError(NOTIFICATION_MESSAGES.ERROR_MESSAGE);
                }
              })
              .catch(() => {
                Snackbar.popError(NOTIFICATION_MESSAGES.ERROR_SUBSCRIBE);
              });
          } else {
            Snackbar.popError(NOTIFICATION_MESSAGES.ERROR_MESSAGE);
          }
        } else {
          Snackbar.popError(NOTIFICATION_MESSAGES.REJECT_MESSAGE);
        }
      })
      .catch(() => {
        Snackbar.popError(NOTIFICATION_MESSAGES.ERROR_MESSAGE);
      });
  }

  @Watch("contextPanelStatus")
  handleInnerWith() {
    if (this.contextPanelStatus) {
      this.contentCols = 8;
      this.panelCols = 4;
    } else {
      this.contentCols = 11;
      this.panelCols = 1;
    }
  }
}
